import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Login-User",
  "use": "icon-Login-User-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Login-User\">\r\n<g id=\"icon-Login-User_&#232;&#180;&#166;&#229;&#143;&#183;\">\r\n<circle id=\"icon-Login-User_Ellipse 180\" cx=\"15\" cy=\"10\" r=\"4.25\" stroke=\"#A9ADB5\" stroke-width=\"1.5\" />\r\n<path id=\"icon-Login-User_Rectangle 24686\" d=\"M23 25V25C23 21.134 19.866 18 16 18H14C10.134 18 7 21.134 7 25V25\" stroke=\"#A9ADB5\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol